// extracted by mini-css-extract-plugin
export default {"array":"index_array__PT8dW"};